export { UredniDeskyModule } from './uredni-desky.module';
export {CompactUredniDeskyComponent } from './compact/compact.component';
export { TwoColumnUredniDeskyComponent} from './two-column/two-column.component';
